import endpoints from 'api/endpoints';
import { normalize } from 'normalizr';
import { story } from 'schemas';
import Immutable from 'immutable';

export default ({ requestBody }) => ({
  url: endpoints.getDeleteStoryUrl(requestBody.id),
  queryKey: `put${endpoints.getDeleteStoryUrl()}`,
  transform: response => normalize(response.data, story.schema).entities,
  body: requestBody,
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: 'application/json',
    },
    method: 'PUT',
  },
  update: {
    story: (prevStory = Immutable.Map(), nextStory) => prevStory.mergeDeep(nextStory),
  },
});
